import * as types from '../constants/actionTypes';
import initialState from './initialState';
import Immutable from 'seamless-immutable';
import { FORUM_DATAKEY } from '../constants/constants';
// import _ from "lodash";

export default function forumReducer(state = initialState.forumState, action) {
  switch (action.type) {
    case types.UPDATE_STATE_FORUM_STATE: {
      return state.merge({ ...action.data });
    }
    case types.TOGGLE_REGIONAL_FORUM_LOCATION: {
      return state.set('isShowRegionalForumLocationModal', action.data);
    }
    case types.UPDATE_TRENDING_TOPIC_STATE: {
      const { trendingTopic } = Immutable.asMutable(state);
      return state.merge({
        trendingTopic: { ...trendingTopic, ...action.params },
      });
    }
    case types.UPDATE_NEWEST_TOPIC_STATE: {
      const { newestTopic } = Immutable.asMutable(state);
      return state.merge({ newestTopic: { ...newestTopic, ...action.params } });
    }
    case types.UPDATE_FOLLOWING_TOPIC_STATE: {
      const { followingTopic } = Immutable.asMutable(state);
      return state.merge({
        followingTopic: { ...followingTopic, ...action.params },
      });
    }
    case types.UPDATE_MY_TOPIC_STATE: {
      const { myTopic } = Immutable.asMutable(state);
      return state.merge({ myTopic: { ...myTopic, ...action.params } });
    }
    case types.UPDATE_SUB_TOPIC_STATE: {
      const { subForumTopic } = Immutable.asMutable(state);
      return state.merge({
        subForumTopic: { ...subForumTopic, ...action.params },
      });
    }
    case types.UPDATE_FORUM_TOPIC_STATE: {
      const { forumTopic } = Immutable.asMutable(state);
      return state.merge({ forumTopic: { ...forumTopic, ...action.params } });
    }
    case types.GET_BOARD_DATA_SUCCESS: {
      const { data } = action;
      const updateObject = {
        forumList: data,
        isLoadingForum: false,
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_BOARD_DATA_SUMMARY_SUCCESS: {
      const { data } = action;
      const updateObject = {
        forumSummaryList: data,
        isLoadingForumSummary: false,
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_TRENDING_FORUM_SUCCESS: {
      const { trendingTopic } = Immutable.asMutable(state);
      const { params, data } = action;
      const pageSize = params && params.size ? params.size : 12;
      let updateObject = {
        trendingTopic: {
          data: !params || (params && !params.page) ? data : [...trendingTopic.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMoreData: data && data.length === pageSize,
        },
      };
      if (!params || (params && !params.onlyData)) {
        updateObject = {
          ...updateObject,
          newestTopic: {
            data: [],
            isLoading: false,
            page: 1,
            isHasMoreData: true,
          },
        };
      }
      return state.merge({ ...updateObject });
    }
    case types.GET_NEWEST_FORUM_SUCCESS: {
      const { newestTopic } = Immutable.asMutable(state);
      const { params, data } = action;
      const pageSize = params && params.size ? params.size : 12;
      let updateObject = {
        newestTopic: {
          data: !params || (params && !params.page) ? data : [...newestTopic.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMoreData: data && data.length === pageSize,
        },
      };
      if (!params || (params && !params.onlyData)) {
        updateObject = {
          ...updateObject,
          trendingTopic: {
            data: [],
            isLoading: false,
            page: 1,
            isHasMoreData: true,
          },
        };
      }
      return state.merge({ ...updateObject });
    }
    case types.GET_MY_TOPIC_SUCCESS: {
      const { myTopic } = Immutable.asMutable(state);
      const { params, data, total } = action;
      const updateObject = {
        myTopic: {
          data: !params || (params && !params.page) ? data : [...myTopic.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMoreData: data && data.length === 12,
          isLoadedFirstData: true,
          total,
        },
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_MY_TOPIC_DESKTOP_SUCCESS: {
      const { params, data, total } = action;
      const pageSize = params && params.size ? params.size : 12;
      const updateObject = {
        myTopic: {
          data: !params || (params && !params.page) ? data : data,
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMoreData: data && data.length === 12,
          isLoadedFirstData: true,
          total,
          totalPages: total ? Math.ceil(total / pageSize) : 0,
        },
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_FOLLOWING_TOPIC_SUCCESS: {
      const { followingTopic } = Immutable.asMutable(state);
      const { params, data } = action;
      const updateObject = {
        followingTopic: {
          data: !params || (params && !params.page) ? data : [...followingTopic.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMoreData: data && data.length === 12,
          isLoadedFirstData: true,
        },
      };
      return state.merge({ ...updateObject });
    }

    case types.GET_FOLLOWING_TOPIC_DESKTOP_SUCCESS: {
      const { params, data, pagination } = action;
      const updateObject = {
        followingTopic: {
          data: !params || (params && !params.page) ? data : data,
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMoreData: data && data.length === 12,
          isLoadedFirstData: true,
          total: (pagination && pagination.TotalItems) || 0,
          totalPages: (pagination && pagination.TotalPages) || 0,
        },
      };
      return state.merge({ ...updateObject });
    }

    case types.GET_SUB_FORUM_SUCCESS: {
      const updateObject = {
        isLoadingSubForumList: false,
        subForumList: action.data,
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_FORUM_TOPIC_SUCCESS: {
      const { forumTopic } = Immutable.asMutable(state);
      const { params, data } = action;
      const updateObject = {
        forumTopic: {
          currentForumID: params.id,
          data: !params || (params && (!params.page || params.isClearData)) ? data : [...forumTopic.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMoreData: data && data.length === 12,
          lastMessageItem: data.lastMessageItem,
        },
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_SUB_FORUM_TOPIC_SUCCESS: {
      const { subForumTopic } = Immutable.asMutable(state);
      const { params, data } = action;
      const updateObject = {
        subForumTopic: {
          currentForumID: params.id,
          data: !params || (params && (!params.page || params.isClearData)) ? data : [...subForumTopic.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMoreData: data && data.length === 12,
          lastMessageItem: data.lastMessageItem,
        },
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_SEARCH_FORUM_BY_TAGS_SUCCESS: {
      const { topicSearchByTags } = Immutable.asMutable(state);
      const { params, data } = action;
      const topics = data.data;
      const hasMoreData = params && params.size ? topics && topics.length === params.size : topics && topics.length === 12;
      const updateObject = {
        topicSearchByTags: {
          data: !params || (params && !params.page) || (params && params.page === 1) ? topics : [...topicSearchByTags.data, ...topics],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMoreData: hasMoreData,
          total: data.pagingInfo.totalItems,
          totalPages: data.pagingInfo.totalPages,
        },
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_SEARCH_RESULT_BY_TAGS_SUCCESS: {
      const { topicSearchByTags } = Immutable.asMutable(state);
      const { params, data } = action;
      // console.log(action)
      const hasMoreData = params && params.size ? data && data.length === params.size : data && data.length === 12;
      const updateObject = {
        topicSearchByTags: {
          data: !params || (params && !params.page) || (params && params.page === 1) ? data : [...topicSearchByTags.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMoreData: hasMoreData,
        },
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_SUB_TOPIC_MORE_MESSAGE_SUCCESS: {
      const { topicDetails } = Immutable.asMutable(state);
      const { data, params } = action;
      const pageIsExist = topicDetails.pageCommentLoaded.filter(item => item.page === params.page).length > 0;
      let pageCommentLoaded = [
        {
          page: params.page,
          value: data.messages,
        },
      ];
      if (!params.clear) {
        if (pageIsExist) {
          pageCommentLoaded = [...topicDetails.pageCommentLoaded];
        } else {
          pageCommentLoaded =
            (params && params.page === 1) || (params && !params.page) || data.paginationInfo.page === 1
              ? [{ page: params.page, value: data.messages }]
              : [...topicDetails.pageCommentLoaded, { page: params.page, value: data.messages }];
        }
      }
      let message = data.messages;
      if (!params.clear) {
        if (pageIsExist) {
          message = [...topicDetails.messages];
        } else if ((params && params.page === 1) || (params && !params.page) || data.paginationInfo.page === 1) {
          message = data.messages;
        } else {
          message =
            topicDetails.paginationInfo.page > params.page ? [...data.messages, ...topicDetails.messages] : [...topicDetails.messages, ...data.messages];
        }
      }
      let paginationInfo = {
        ...topicDetails.paginationInfo,
        page: params.page,
      };
      if (!params.clear) {
        paginationInfo = pageIsExist ? topicDetails.paginationInfo : data.paginationInfo;
      }
      const currentPage = params.page !== 0 ? params.page : topicDetails.currentPage;
      return state
        .setIn(['topicDetails', 'messages'], message)
        .setIn(['topicDetails', 'pageCommentLoaded'], pageCommentLoaded)
        .setIn(['isLoadingTopicDetailsComment'], false)
        .setIn(['topicDetails', 'paginationInfo'], paginationInfo)
        .setIn(['topicDetails', 'currentPage'], currentPage);
    }
    case types.POST_CREATE_FORUM_TOPIC_LIKE_SUCCESS: {
      let { index } = action.params;
      const { id, dataKey, likeCount, from } = action.params;
      if (dataKey && !index && state[dataKey] && state[dataKey].data.length > 0) {
        index = state[dataKey].data.findIndex(itm => itm.id === id);
      }
      if (from === 'topicDetails') {
        return state
          .setIn([from, 'topic', 'isLiked'], true)
          .setIn([from, 'topic', 'likeCount'], likeCount + 1)
          .setIn([dataKey, 'data', index, 'isLiked'], true)
          .setIn([dataKey, 'data', index, 'contentItem', 'likeCount'], likeCount + 1);
      }
      return state.setIn([dataKey, 'data', index, 'isLiked'], true).setIn([dataKey, 'data', index, 'contentItem', 'likeCount'], likeCount + 1);
    }
    case types.POST_CREATE_FORUM_TOPIC_UNLIKE_SUCCESS: {
      let { index } = action.params;
      const { id, dataKey, likeCount, from } = action.params;
      if (dataKey && !index && state[dataKey] && state[dataKey].data.length > 0) {
        index = state[dataKey].data.findIndex(itm => itm.id === id);
      }
      if (from === 'topicDetails') {
        state = state.setIn([from, 'topic', 'isLiked'], false).setIn([from, 'topic', 'likeCount'], likeCount - 1);
        if (index !== -1) {
          state = state.setIn([dataKey, 'data', index, 'isLiked'], false).setIn([dataKey, 'data', index, 'contentItem', 'likeCount'], likeCount - 1);
        }
        return state;
      }
      return state.setIn([dataKey, 'data', index, 'isLiked'], false).setIn([dataKey, 'data', index, 'contentItem', 'likeCount'], likeCount - 1);
    }
    case types.POST_CREATE_TOPIC_FOLLOWING_SUCCESS: {
      const { index, dataKey, from } = action.params;
      if (from === 'topicDetails') {
        state = state.setIn([from, 'topic', 'isFollowing'], true);
        if (dataKey && !index && state[dataKey] && state[dataKey].data.length > index) {
          state = state.setIn([dataKey, 'data', index, 'isFollowing'], true);
        }
        return state;
      }
      return state.setIn([dataKey, 'data', index, 'isFollowing'], true);
    }
    case types.POST_CREATE_TOPIC_UN_FOLLOW_SUCCESS: {
      const { id, index, dataKey, from } = action.params;
      const { trendingTopic, newestTopic } = Immutable.asMutable(state);
      if (from === 'topicDetails') {
        state = state.setIn([from, 'topic', 'isFollowing'], false);
        if (dataKey && !index && state[dataKey] && state[dataKey].data.length > index) {
          state = state.setIn([dataKey, 'data', index, 'isFollowing'], false);
        }
        return state;
      }
      state = state.setIn([dataKey, 'data', index, 'isFollowing'], false);
      let indexOfMainForum = -1;
      let newDataKey = null;
      if (dataKey === FORUM_DATAKEY.FOLLOWING) {
        indexOfMainForum = trendingTopic.data.findIndex(itm => itm.id === id);
        newDataKey = FORUM_DATAKEY.TRENDING_TOPIC;
        if (indexOfMainForum === -1) {
          indexOfMainForum = newestTopic.data.findIndex(itm => itm.id === id);
          newDataKey = FORUM_DATAKEY.NEWEST_TOPIC;
        }
      }
      if (indexOfMainForum !== -1) {
        state = state.setIn([newDataKey, 'data', indexOfMainForum, 'isFollowing'], false);
      }

      return state;
    }
    case types.DELETE_TOPIC: {
      const { data } = action;
      const d = Immutable.asMutable(state[data.dataKey]);
      if (d && typeof d === 'object') {
        const filterData =
          d && d.data && d.data.filter(item => item && item.contentItem && item.contentItem.owner && item.contentItem.owner.userId !== data.userId);
        if (filterData && typeof filterData === 'object') {
          return state.setIn([data.dataKey, 'data'], filterData);
        }
      }
      return state;
    }
    case types.GET_TOPIC_MESSAGE_COMMENT_SUCCESS: {
      const { topicDetails } = Immutable.asMutable(state);
      const { data, id, paging } = action;
      // if (data && data.comments && data.comments.length > 0) {
      const findIdx = topicDetails.messages.findIndex(item => item.id === id);
      const customPaging = !!paging ? paging : topicDetails.messages[findIdx].paging + 1;
      const msgData =
        (data && (data.paginationInfo && data.paginationInfo.page === 1 ? data.comments : [...topicDetails.messages[findIdx].comments, ...data.comments])) ||
        [];
      if (data) {
        if (data.paginationInfo && data.paginationInfo.page === 1) {
          return state
            .setIn(['topicDetails', 'messages', findIdx, 'comments'], msgData)
            .setIn(['topicDetails', 'messages', findIdx, 'paginationInfo'], data.paginationInfo)
            .setIn(['topicDetails', 'messages', findIdx, 'paging'], customPaging);
        }
        return state
          .setIn(['topicDetails', 'messages', findIdx, 'comments'], msgData)
          .setIn(['topicDetails', 'messages', findIdx, 'paginationInfo'], data.paginationInfo)
          .setIn(['topicDetails', 'messages', findIdx, 'paging'], customPaging);
      }
      return state;
      //  }
    }
    case types.POST_CREATE_TOPIC_MESSAGE_LIKE_SUCCESS: {
      const { topicDetails } = Immutable.asMutable(state);
      const { id, likeCount, index, isCommentsMsg, msgIndex } = action.params;
      //  console.log(action)
      // let index = topicDetails.messages.findIndex(i => i.id === id);
      if (isCommentsMsg) {
        return state
          .setIn(['topicDetails', 'messages', msgIndex, 'comments', index, 'isLiked'], true)
          .setIn(['topicDetails', 'messages', msgIndex, 'comments', index, 'likeCount'], likeCount + 1);
      }
      return state.setIn(['topicDetails', 'messages', index, 'isLiked'], true).setIn(['topicDetails', 'messages', index, 'likeCount'], likeCount + 1);
    }
    case types.POST_CREATE_TOPIC_MESSAGE_UNLIKE_SUCCESS: {
      const { topicDetails } = Immutable.asMutable(state);
      const { id, likeCount, index, isCommentsMsg, msgIndex } = action.params;
      //     console.log(action)
      // let index = topicDetails.messages.findIndex(i => i.id === id);
      if (isCommentsMsg) {
        return state
          .setIn(['topicDetails', 'messages', msgIndex, 'comments', index, 'isLiked'], false)
          .setIn(['topicDetails', 'messages', msgIndex, 'comments', index, 'likeCount'], likeCount - 1);
      }
      return state.setIn(['topicDetails', 'messages', index, 'isLiked'], false).setIn(['topicDetails', 'messages', index, 'likeCount'], likeCount - 1);
    }
    case types.POST_CREATE_TOPIC_MESSAGE_REPLY_SUCCESS: {
      const { topicDetails } = Immutable.asMutable(state);
      const { id, params } = action;
      const index = topicDetails.messages.findIndex(i => i.id === id);
      const cmMsg = [...topicDetails.messages[index].comments, params.data];
      return state.setIn(['topicDetails', 'messages', index, 'comments'], cmMsg);
    }
    case types.POST_CREATE_TOPIC_MESSAGE_SUCCESS: {
      const { topicDetails } = Immutable.asMutable(state);
      const { params } = action;
      // console.log("params", params)
      if (
        topicDetails &&
        topicDetails.currentPage === topicDetails.paginationInfo.totalPages &&
        topicDetails.messages
        // &&
        // topicDetails.messages.length % 10 !== 0
      ) {
        return state.setIn(
          ['topicDetails', 'messages'],
          [
            ...topicDetails.messages,
            {
              ...params,
              paging: topicDetails.currentPage,
            },
          ]
        );
      }
      return state;
    }
    case types.DELETE_TOPIC_MESSAGE_SUCCESS:
    case types.DELETE_THREAD_MESSAGE: {
      const { topicDetails } = Immutable.asMutable(state);
      const { params } = action;
      if (params && params.parentItem) {
        const parentIndex = topicDetails.messages.findIndex(item => item.id === params.parentItem.id);
        if (parentIndex !== -1) {
          const d = topicDetails.messages[parentIndex].comments.filter(i => i.id !== params.id);
          state = state.setIn(['topicDetails', 'messages', [parentIndex], 'comments'], d);
          return state.setIn(['topicDetails', 'topic', 'replyCount'], topicDetails.topic.replyCount - 1);
        }
      } else {
        const currMessages = topicDetails.messages.find(i => i.id === params.id);
        const newMessages = topicDetails.messages.filter(i => i.id !== params.id);
        let step = 0;
        if (currMessages && currMessages.comments && currMessages.comments.length > 0) {
          step = currMessages.comments.length;
        }
        return state.merge({ topicDetails: {
          ...topicDetails,
            messages: newMessages,
            topic: {
              ...topicDetails.topic,
              replyCount: topicDetails.topic.replyCount - 1 - step,
            },
        } });
      }
      return state;
    }
    case types.TOPIC_LIKE_USER: {
      // console.log(action)
      const { likeUser } = Immutable.asMutable(state);
      const { params, data } = action;
      const updateObject = {
        likeUser: {
          data: !params || (params && !params.page) ? data : [...likeUser.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMoreData: data && data.length === 12,
        },
      };
      return state.merge({ ...updateObject });
    }
    case types.UPDATE_TOPIC_LIKE_USER: {
      const { actionType, user, id } = action;
      const { likeUser } = Immutable.asMutable(state);
      // console.log(action)
      let updateObject = null;
      if (actionType === types.ACTION_TYPE.LIKE && user) {
        updateObject = {
          likeUser: {
            ...likeUser,
            data: [user, ...likeUser.data],
          },
        };
      } else {
        if (id) {
          updateObject = {
            likeUser: {
              ...likeUser,
              data: likeUser.data.filter(i => i.userId !== id),
            },
          };
        }
      }
      // console.log(updateObject)
      if (updateObject && typeof updateObject === 'object') {
        return state.merge({ ...updateObject });
      }
      return state;
    }
    case types.UPDATE_SEARCH_RESULT_BY_TAGS_STATE: {
      // console.log(action)
      const { topicSearchByTags } = Immutable.asMutable(state);
      return state.merge({
        topicSearchByTags: { ...topicSearchByTags, ...action.params },
      });
    }
    default:
      return state;
  }
}
